import { eg, type SetupExample } from "@/lib/setup/examples";
import { TermChips } from "./TermChips";

export function AngleCard({ label, question, terms, onLabel, onQuestion, onTerms, facets, example }: {
  label: string; question: string; terms: string;
  onLabel: (v: string) => void; onQuestion: (v: string) => void; onTerms: (v: string) => void;
  /** Facets users: the label is the angle's own (a Curate tab). Others: it is the concept name. */
  facets: boolean;
  example: SetupExample;
}) {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-primary/40 bg-primary/10 p-5">
      <div>
        <p className="font-medium">Your first angle</p>
        <p className="text-sm text-muted-foreground">Drafted from your words — click anything to edit</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <input
          aria-label={facets ? "Angle label" : "Angle label (concept name)"}
          value={label} onChange={(e) => onLabel(e.target.value)} placeholder={eg(example.label)} maxLength={80}
          size={Math.max(12, (label || eg(example.label)).length + 1)}
          className="max-w-full rounded-full border border-primary/50 bg-background px-3 py-1 font-medium"
        />
        {facets && <span className="text-xs text-muted-foreground">angle label · shows as a tab in Curate</span>}
      </div>
      <textarea
        aria-label="Research question" rows={3} value={question} onChange={(e) => onQuestion(e.target.value)}
        placeholder={eg(example.question)}
        className="w-full resize-none rounded-md border border-transparent bg-transparent p-1 text-base hover:border-border focus:border-border focus:bg-background"
      />
      <div className="flex flex-col gap-2">
        <span className="text-sm text-muted-foreground">Searches with</span>
        <TermChips value={terms} onChange={onTerms} />
      </div>
      {facets && (
        <p className="text-sm text-muted-foreground">
          One angle is plenty to start. You can split the project into more angles later, from Curate.
        </p>
      )}
    </div>
  );
}
